import { STAFF_MEMORY_PATHS, staffCustomerListSchema, staffCustomerMemoryFactsPath, staffCustomerMemoryPath, staffCustomerMemoryViewSchema, staffMemoryCommandOutcomeSchema, staffMemoryFactDetailSchema, staffMemoryFactPath, } from "@lafayette/schemas";
import { createMemoryTransport, } from "./memory-transport";
export function createStaffCustomerMemoryApi(options) {
    const send = createMemoryTransport(options);
    const command = (path, body, commandOptions) => send({
        method: "POST",
        path,
        body,
        schema: staffMemoryCommandOutcomeSchema,
        idempotencyKey: commandOptions?.idempotencyKey,
        signal: commandOptions?.signal,
    });
    const factCommand = (factId, subpath, body, commandOptions) => command(staffMemoryFactPath(factId, subpath), body, commandOptions);
    return {
        listCustomers: (query, callOptions) => send({
            method: "GET",
            path: STAFF_MEMORY_PATHS.customers,
            schema: staffCustomerListSchema,
            ...(query?.limit === undefined
                ? {}
                : { query: new URLSearchParams({ limit: String(query.limit) }) }),
            signal: callOptions?.signal,
        }),
        getCustomerMemory: (customerId, query, callOptions) => {
            const params = new URLSearchParams();
            if (query?.includeClosed !== undefined) {
                params.set("includeClosed", query.includeClosed ? "true" : "false");
            }
            if (query?.limit !== undefined)
                params.set("limit", String(query.limit));
            return send({
                method: "GET",
                path: staffCustomerMemoryPath(customerId),
                schema: staffCustomerMemoryViewSchema,
                query: params,
                signal: callOptions?.signal,
            });
        },
        getFact: (factId, callOptions) => send({
            method: "GET",
            path: staffMemoryFactPath(factId),
            schema: staffMemoryFactDetailSchema,
            signal: callOptions?.signal,
        }),
        recordFact: (customerId, input, commandOptions) => command(staffCustomerMemoryFactsPath(customerId), input, commandOptions),
        activateFact: (factId, input, commandOptions) => factCommand(factId, "activate", input, commandOptions),
        rejectCandidate: (factId, input, commandOptions) => factCommand(factId, "reject", input, commandOptions),
        acceptCandidate: (factId, input, commandOptions) => factCommand(factId, "accept", input, commandOptions),
        confirmFact: (factId, input, commandOptions) => factCommand(factId, "confirm", input, commandOptions),
        disputeFact: (factId, input, commandOptions) => factCommand(factId, "dispute", input, commandOptions),
        resolveDispute: (factId, input, commandOptions) => factCommand(factId, "resolve", input, commandOptions),
        correctFact: (factId, input, commandOptions) => factCommand(factId, "correct", input, commandOptions),
        deleteFact: (factId, input, commandOptions) => factCommand(factId, "delete", input, commandOptions),
    };
}
